export const mediaSrc = (u) => {
  if (!u) return "";
  if (/^(https?:|blob:|data:)/i.test(u)) return u;
  return `${process.env.REACT_APP_BACKEND_URL}${u}`;
};
export const resolveImg = (u) => (u && u.startsWith("/api/") ? mediaSrc(u) : u);
